import { render, staticRenderFns } from "./FamilyUserSummary.vue?vue&type=template&id=3b2558be&"
import script from "./FamilyUserSummary.vue?vue&type=script&lang=js&"
export * from "./FamilyUserSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports